import { actionConst } from '../constants/execute-time.constants';

const defaultState = {
	executeTimeModalVisible: false,
	setExecuteTimeRequestID: undefined,
	executerModalVisible: false,
	setExecuterRequestID: undefined,
	masterModalVisible: false,
	setMasterRequestID: undefined,
	request: undefined,
  calendarModalVisible: false,
	newStatus: undefined,
	newStatusDescription: undefined,
	requestData: undefined,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.SHOW_EXECUTE_TIME_OK: {
			return {
				...state,
				setExecuteTimeRequestID: action.payload,
			}
		}
		case actionConst.HIDE_EXECUTE_TIME_OK: {
			return {
				...state,
				setExecuteTimeRequestID: undefined
			}
		}
		case actionConst.OPEN_CALENDAR_MODAL: {
			return {
				...state,
				request: action.payload.rid,
				executerId: action.payload.eid,
				eventId: action.payload.cid,
				eventStart: action.payload.start,
				eventStop: action.payload.end,
				calendarModalVisible: true,
			}
		} 
		case actionConst.OPEN_EXECUTE_TIME_MODAL: {
				return {
				...state,				
				newStatus: action.payload.newStatus, 
				newStatusDescription: action.payload.newStatusDescription,
				request: action.payload.rid,
				executeTimeModalVisible: true,
				requestData: action.payload.rData,
			}
		}
		case actionConst.CLOSE_CALENDAR_MODAL: {
			return {
				...state,
				//eventId: null,
				calendarModalVisible: false,				
			}
		}
		case actionConst.CLOSE_EXECUTE_TIME_MODAL: {
			return {
				...state,
				newStatus: undefined, 
				newStatusDescription: undefined,
				executeTimeModalVisible: false,
				requestData: undefined,
			}
		}
		case actionConst.SHOW_EXECUTER_OK: {
			return {
				...state,
				setExecuterRequestID: action.payload,
			}
		}
		case actionConst.HIDE_EXECUTER_OK: {
			return {
				...state,
				setExecuterRequestID: undefined
			}
		}
		case actionConst.OPEN_EXECUTER_MODAL: {
			return {
				...state,
				request: action.payload.r,
				executer: action.payload.e,
				//param: action.payload.p,
				executerModalVisible: true,
			}
		}
		case actionConst.OPEN_MASTER_MODAL: {
			return {
				...state,
				request: action.payload.r,
				master: action.payload.e,
				//param: action.payload.p,
				masterModalVisible: true,
			}
		}
		case actionConst.CLOSE_EXECUTER_MODAL: {
			return {
				...state,
				executerModalVisible: false
			}
		}
		case actionConst.SHOW_MASTER_OK: {
			return {
				...state,
				setMasterRequestID: action.payload,
			}
		}
		case actionConst.HIDE_MASTER_OK: {
			return {
				...state,
				setMasterRequestID: undefined
			}
		}
		case actionConst.CLOSE_MASTER_MODAL: {
			return {
				...state,
				masterModalVisible: false
			}
		}

		default:
			return state;
	}
}